import React from 'react'
import { whatsapp2 } from '../../assets'

function ButtonCTA() {
  return (
    <button style={{position: "fixed", bottom: "0", left: "0", padding: "8px", backgroundColor: "#f8ca0a", border: "none", borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center", columnGap: "5px", boxShadow: "0px 0px 3px #000" }}>
      <img src={whatsapp2} alt="whatsapp" />
      <a href='https://api.whatsapp.com/send/?phone=6285241329911&text=Hallo+Black+Canyon+Transport+,%20Saya%20mau%20pesan%20mobil...' className='text-dark text-decoration-none' target="_blanks">Booking Via Whatsapp</a>
    </button>
  )
}

export default ButtonCTA